import React, { useState, useEffect } from 'react';
import { Row, Col, FormGroup, Label, Input, Button, Card, CardBody, Spinner, CardHeader } from 'reactstrap';
import toast, { Toaster } from 'react-hot-toast';
import { FaPlus, FaTrash, FaUpload } from 'react-icons/fa';
import axios from 'axios';
import uuid from 'react-uuid';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import useLocalStorage from "../Utilities/Hooks/useLocalStorage";
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const CouncilAndLandInfo = ({ userId, councilAndLandInfo, setCouncilAndLandInfo, councilAndLandRows, setCouncilAndLandRows, setCouncilLandChanged, onCatchmentChange, onLegalTitleChange, legalTitle, isCatchment, onCouncilChange, isCouncil }) => {
    const roleName = localStorage.getItem("roleName"); const [showEnvironmentCanterbury, setShowEnvironmentCanterbury] = useState(false);
    //const isAddEditItem = localStorage.getItem("isAddEditItem");
    //const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const [farmRoleName, setFarmRoleName] = useLocalStorage('farmRoleName', null);
    const [formConsentErrors, setFormConsentErrors] = useState([]); let inputFile = []; let inputConsentFile = [];
    const [loading, setLoading] = useState(true); const [saving, setSaving] = useState('');
    /*const [councilAndLandRows, setCouncilAndLandRows] = useState([]);*/
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const [catchmentList, setcatchmentList] = useState([]);
    const [filteredCatchmentList, setFilteredCatchmentList] = useState([]);
    const [consentTypes, setConsentTypes] = useState([]); const [regionalCouncilList, setRegionalCouncilList] = useState([]); const [advisorList, setAdvisorList] = useState([]);
    /*const [councilAndLandInfo, setCouncilAndLandInfo] = useState({ RegionalCouncil: 0, AdvisorId: 0, ValuationReference: '', LandParcels: '', OtherRelevantIdentifier: '', ResponsiblePerson :'',Catchment:0});*/
    const populateItemData = async () => {
        try {
            const response = await apiGet(
                '/api/enterprises/GetCouncilAndLandInfo/', {
                params: { Id: farmId }
            }
            );
            setCouncilAndLandRows(response.data.content.farmCouncilLandInfos);
            setConsentTypes(response.data.content.consentTypes);
            setRegionalCouncilList(response.data.content.regionalCouncilList);
            setcatchmentList(response.data.content.catchmentList);
            setFilteredCatchmentList()
            setAdvisorList(response.data.content.advisorList);
            setShowEnvironmentCanterbury(response.data.content.showEnvironmentCanterbury);
            setCouncilAndLandInfo({
                ...councilAndLandInfo, RegionalCouncil: response.data.content.regionalCouncil,Catchment : response.data.content.catchmentId , AdvisorId: response.data.content.advisorId
                , ValuationReference: response.data.content.valuationReference, LandParcels: response.data.content.landParcels, OtherRelevantIdentifier: response.data.content.otherRelevantIdentifier
                , ResponsiblePerson: response.data.content.responsiblePerson, TotalPropertySize: response.data.content.totalPropertySize
                , PlantedGrapeArea: response.data.content.plantedGrapeArea
            });
            const filteredList = [
                { councilId: "", name: "Select" }, 
                ...response.data.content.catchmentList.filter(
                    (catchment) => catchment.councilId == councilAndLandInfo.RegionalCouncil
                ),
            ];
            setFilteredCatchmentList(filteredList);
            if (councilAndLandInfo.Catchment) {
                onCatchmentChange(councilAndLandInfo.Catchment);
            } else {
                onCatchmentChange("-1");
            }
            if (councilAndLandInfo.RegionalCouncil) {
                onCouncilChange(councilAndLandInfo.RegionalCouncil);
            } else {
                onCouncilChange("-1");
            }
            let tempErrors = [];
            response.data.content.farmCouncilLandInfos.forEach(function (element) {
                const error = {
                    fileError: ''
                };
                tempErrors.push(error);
            });
            setFormConsentErrors(tempErrors);

            setLoading(false);
        }
        catch (err) {
            if (!err?.response) {

            } else if (err.response?.status === 400) {

            } else {

            }
        }
    }
    
    useEffect(() => {
        populateItemData();
    }, [loading]);

    const handleCouncilAndLandRowsAddRow = () => {
        setCouncilLandChanged(true);
        const item = {
            consentNumber: "",
            consentConditions: "",
            consentType: "", id: 0, requiredForFEP:false
        };
        setCouncilAndLandRows([...councilAndLandRows, item]);
        const error = {
            fileError: ''
        };
        setFormConsentErrors([...formConsentErrors, error]);
    };

    const handleCouncilAndLandConsentTypeChange = idx => e => {
        setCouncilLandChanged(true);
        const { name, value } = e.target;
        const tempRows = [...councilAndLandRows];
        tempRows[idx].consentType = value;
        setCouncilAndLandRows(tempRows);
    };

    const handleCouncilAndLandConsentNumberChange = idx => e => {
        setCouncilLandChanged(true);
        const { name, value } = e.target;
        const tempRows = [...councilAndLandRows];
        tempRows[idx].consentNumber = value;
        setCouncilAndLandRows(tempRows);
    };

    const handleCouncilAndLandConsentConditionsChange = idx => e => {
        setCouncilLandChanged(true);
        const { name, value } = e.target;
        const tempRows = [...councilAndLandRows];
        tempRows[idx].consentConditions = value;
        setCouncilAndLandRows(tempRows);
    };

    const handleCouncilAndLandConsentRequiredForFEPChange = idx => e => {
        setCouncilLandChanged(true);
        const tempRows = [...councilAndLandRows];
        tempRows[idx].requiredForFEP = e.target.checked;
        setCouncilAndLandRows(tempRows);
    };

    const handleCouncilAndLandRowsRemoveSpecificRow = (idx) => () => {
        setCouncilLandChanged(true);
        const tempRows = [...councilAndLandRows]
        tempRows.splice(idx, 1)
        setCouncilAndLandRows(tempRows);
        const tempErrors = [...formConsentErrors];
        tempErrors.splice(idx, 1)
        setFormConsentErrors(tempErrors);
    }

    const handleConsentBtnUploadClick = async (e, idx) => {
        e.preventDefault();
        inputConsentFile[idx].click();
        return false;
    }

    const handleConsentDateChange = (idx, date) => {
        setCouncilLandChanged(true);
        const tempRows = [...councilAndLandRows];
        tempRows[idx].expiryDateText = getParsedDate(date);
        tempRows[idx].expiryDate = getDateFromString(getParsedDate(date));
        setCouncilAndLandRows(tempRows);
    };

    const getDateFromString = (date) => {
        var dd = date.split('/')[0];
        var mm = date.split('/')[1];
        var yyyy = date.split('/')[2];
        var newDate = new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
        return newDate;
    }

    const handleConsentRecordChange = async (e, idx) => {
        e.preventDefault();
        const tempErrors = [...formConsentErrors];
        let reader = new FileReader();
        let file = e.target.files[0];
        const errors = {};
        if ((file.size / (1024 * 1024)) > 100) {
            errors.fileError = "Sorry, uploads are restricted to a maximum of 100mb per item!";
            tempErrors[idx].fileError = "Sorry, uploads are restricted to a maximum of 100mb per item!";
        }
        else {
            tempErrors[idx].fileError = "";
        }
        setFormConsentErrors(tempErrors);
        if (Object.keys(errors).length == 0) {
            setCouncilLandChanged(true);
            const formData = new FormData();
            formData.append("FarmId", farmId);
            formData.append("ReferenceId", farmId);
            formData.append("Type", 'Consent');
            formData.append("FileName", e.target.files[0].name);
            formData.append("File", e.target.files[0]);
            formData.append("userId", userId);

            const response = await apiPost(
                '/api/uploaddocument/UploadDocument/', formData,
                {
                    headers: { "Content-type": "multipart/form-data", "FarmId": farmId, "ReferenceId": farmId, "Type": 'Consent', "userId": userId, "FileName": e.target.files[0].name },
                    withCredentials: true
                });
            if (response.data != null) {
                if (response.data.status) {
                    const tempRows = [...councilAndLandRows];
                    tempRows[idx].documentName = response.data.content.DocumentName;
                    tempRows[idx].documentPhysicalName = response.data.content.DocumentPhysicalName;
                    tempRows[idx].documentPath = response.data.content.DocumentPath;
                    tempRows[idx].documentRelativePath = response.data.content.RelativeFilepath;
                    setCouncilAndLandRows(tempRows);
                }
            }
        }
        else {
            e.target.value = null;
        }
    }

    const getParsedDate = (date) => {
        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd + "/" + mm + "/" + yyyy;
        return date.toString();
    }
    const handleCatchmentChange = (e) => {
        const newCatchment = e.target.value;
        setCouncilAndLandInfo({
            ...councilAndLandInfo,
            Catchment: newCatchment,
        });
        setCouncilLandChanged(true)
        onCatchmentChange(newCatchment);
        
    };
    
    const handleLegalTitleChange = (e) => {
        const newTitle = e.target.value;
        setCouncilAndLandInfo({
            ...councilAndLandInfo,
            LandParcels: newTitle,
        });
        setCouncilLandChanged(true)
        onLegalTitleChange(newTitle);
        
    };

    const handleTotalPropertySizeChange = (e) => {
        let val = e.target.value;
        if (/^\d*\.?\d{0,1}$/.test(val)) {
            setCouncilAndLandInfo({ ...councilAndLandInfo, TotalPropertySize: val }); setCouncilLandChanged(true)
        }
    };

    const handlePlantedGrapeAreaChange = (e) => {
        let val = e.target.value;
        if (/^\d*\.?\d{0,1}$/.test(val)) {
            setCouncilAndLandInfo({ ...councilAndLandInfo, PlantedGrapeArea: val }); setCouncilLandChanged(true)
        }
    };

    return (
        <Card className="my-4">
            <CardHeader className="card-header card-header-dark d-flex justify-content-between align-items-center">
            <h5>
                Council & Land Information
            </h5>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col sm="6">
                        <FormGroup>
                            <Label className="label" for="name">Regional council</Label>
                        </FormGroup>
                    </Col>
                    <Col sm="6">
                        <FormGroup>
                            {regionalCouncilList == undefined && <p><em>Loading...</em></p>}
                            {regionalCouncilList != undefined && regionalCouncilList != null &&
                                <Input type="select" value={councilAndLandInfo.RegionalCouncil}
                                    onChange={(e) => {
                                        const selectedId = e.target.value;
                                        setCouncilAndLandInfo({
                                            ...councilAndLandInfo,
                                            RegionalCouncil: selectedId,
                                            Catchment: null
                                        });
                                        onCatchmentChange("-1");
                                        setCouncilLandChanged(true);
                                        onCouncilChange(selectedId);
                                        setFilteredCatchmentList([]);
                                        const newCatchments = [
                                            { councilId: "", name: "Select" }, // Blank entry
                                            ...catchmentList.filter(catchment => catchment.councilId == selectedId),
                                        ];
                                        setFilteredCatchmentList(newCatchments);
                                    }}

                                    name="RegionalCouncil" id="RegionalCouncil" style={{
                                        borderColor: !isCouncil  ? "red" : "",
                                        borderWidth: !isCouncil ? "2px" : "",
                                    }} >
                                    {regionalCouncilList.map(items =>
                                        <option key={uuid()} value={items.id}>{items.name}</option>
                                    )}
                                </Input>
                            }
                            {!isCouncil && (
                                <span style={{ color: "red", fontSize: "12px" }}>
                                    * This field is mandatory
                                </span>
                            )}
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm="6">
                        <FormGroup>
                            <Label className="label" for="name">Catchment</Label>
                        </FormGroup>
                    </Col>
                    <Col sm="6">
                        <FormGroup>
                            {filteredCatchmentList == undefined && <p><em>Loading...</em></p>}
                            {filteredCatchmentList != undefined && filteredCatchmentList != null &&
                                <Input type="select" value={councilAndLandInfo.Catchment} onChange={handleCatchmentChange} name="Catchment" id="Catchment" style={{
                                    borderColor: !isCatchment ? "red" : "",
                                    borderWidth: !isCatchment ? "2px" : "",
                                }} >
                                    {filteredCatchmentList.map(items =>
                                        <option key={uuid()} value={items.id}>{items.name}</option>
                                    )}
                                </Input>
                            }
                            
                            {!isCatchment && (
                                <span style={{ color: "red", fontSize: "12px" }}>
                                    * This field is mandatory
                                </span>
                            )}
                        </FormGroup>
                    </Col>
                    
                </Row>
                {/*<Row>*/}
                {/*    <Col sm="6">*/}
                {/*        <FormGroup>*/}
                {/*            <Label className="label" for="name">Valuation reference</Label>*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*    <Col sm="6">*/}
                {/*        <FormGroup>*/}
                {/*            <Input type="text" value={councilAndLandInfo.ValuationReference} onChange={(e) => { setCouncilAndLandInfo({ ...councilAndLandInfo, ValuationReference: e.target.value }); setCouncilLandChanged(true); }} name="ValuationReference" id="ValuationReference" autoComplete="new-password" />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*</Row>*/}
                <Row>
                    <Col sm="6">
                        <FormGroup>
                            <Label className="label" for="name"><label style={{ color: "red" }}>*</label>Legal land titles and parcels of the vineyard</Label>
                        </FormGroup>
                    </Col>
                    <Col sm="6">
                        <FormGroup>
                            <Input type="textarea" value={councilAndLandInfo.LandParcels} onChange={handleLegalTitleChange} name="LandParcels" id="LandParcels" autoComplete="new-password" style={{
                                borderColor: !legalTitle  ? "red" : "",
                                borderWidth: !legalTitle  ? "2px" : "",
                            }} />
                            {!legalTitle && (
                                <span style={{ color: "red", fontSize: "12px" }}>
                                    * This field is mandatory
                                </span>
                            )}
                        </FormGroup>
                    </Col>
                   
                </Row>
                <Row>
                    <Col sm="6">
                        <FormGroup>
                            <Label className="label" for="name">Total Property Size (ha)</Label>
                        </FormGroup>
                    </Col>
                    <Col sm="6">
                        <FormGroup>
                            <Input type="number" value={councilAndLandInfo.TotalPropertySize} onChange={(e) => { handleTotalPropertySizeChange(e) }} name="TotalPropertySize" id="TotalPropertySize" autoComplete="new-password" />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm="6">
                        <FormGroup>
                            <Label className="label" for="name">Planted Grape Area (ha)</Label>
                        </FormGroup>
                    </Col>
                    <Col sm="6">
                        <FormGroup>
                            <Input type="number" value={councilAndLandInfo.PlantedGrapeArea} onChange={(e) => { handlePlantedGrapeAreaChange(e)}} name="PlantedGrapeArea" id="PlantedGrapeArea" autoComplete="new-password" />
                        </FormGroup>
                    </Col>
                </Row>
                <Row style={{ display: "none" }}>
                    <Col sm="6">
                        <FormGroup>
                            <Label className="label" for="name">Other relevant property identifier</Label>
                        </FormGroup>
                    </Col>
                    <Col sm="6">
                        <FormGroup>
                            <Input type="text" value={councilAndLandInfo.OtherRelevantIdentifier} onChange={(e) => { setCouncilAndLandInfo({ ...councilAndLandInfo, OtherRelevantIdentifier: e.target.value }); setCouncilLandChanged(true); } } name="OtherRelevantIdentifier" id="OtherRelevantIdentifier" autoComplete="new-password" />
                        </FormGroup>
                    </Col>
                </Row>
                <Row style={{ display: "none" }}>
                    <Col sm="6">
                        <FormGroup>
                            <Label className="label" for="name">Person responsible for plan implementation</Label>
                        </FormGroup>
                    </Col>
                    <Col sm="6">
                        <FormGroup>
                            <Input type="text" value={councilAndLandInfo.ResponsiblePerson} onChange={(e) => { setCouncilAndLandInfo({ ...councilAndLandInfo, ResponsiblePerson: e.target.value }); setCouncilLandChanged(true); } } name="ResponsiblePerson" id="ResponsiblePerson" autoComplete="new-password" />
                        </FormGroup>
                    </Col>
                </Row>
                <Row style={{ display: "none" }}>
                    <Col sm="6">
                        <FormGroup>
                            <Label className="label" for="name">Assigned Advisor</Label>
                        </FormGroup>
                    </Col>
                    <Col sm="6">
                        <FormGroup>
                            {advisorList == undefined && <p><em>Loading...</em></p>}
                            {advisorList != undefined && advisorList != null &&
                                <Input type="select" value={councilAndLandInfo.AdvisorId} onChange={(e) => { setCouncilAndLandInfo({ ...councilAndLandInfo, AdvisorId: e.target.value }); setCouncilLandChanged(true); } } name="AdvisorId" id="AdvisorId">
                                    {advisorList.map(items =>
                                        <option key={uuid()} value={items.id}>{items.name}</option>
                                    )}
                                </Input>
                            }
                        </FormGroup>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col>
                        {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                            <>
                            <span style={{ marginRight: '10px' }}>
                                Are there any current resource consents held in respect of the farm that are relevant to the preparation of the freshwater farm plan?
                            </span>
                            </>
                        }
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col sm="12">
                        <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                            <thead>
                                <tr>
                                    <th className="text-left"> Consent Type </th>
                                    <th className="text-left"> Number </th>
                                    <th className="text-left"> Consent Condition(s) relating to Freshwater Farm plan </th>
                                    <th className="text-center"> Expiry Date </th>
                                    {/*{showEnvironmentCanterbury &&  */}
                                    {/*    <th className="text-center"> Required for FEP </th>}*/}
                                    <th className="text-center"> Attach Document </th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>
                                {councilAndLandRows != undefined && councilAndLandRows != null && councilAndLandRows.map((item, idx) => (
                                    <tr id="addr0" key={idx}>
                                        <td style={{ display: "none" }}>{councilAndLandRows[idx].id}</td>
                                        <td style={{ width: "12%" }}>
                                            <input
                                                type="text"
                                                name="consentType"
                                                value={councilAndLandRows[idx].consentType}
                                                onChange={handleCouncilAndLandConsentTypeChange(idx)}
                                                className="form-control"
                                            />
                                        </td>
                                        <td style={{ width: "12%" }}>
                                            <input
                                                type="text"
                                                name="consentNumber"
                                                value={councilAndLandRows[idx].consentNumber}
                                                onChange={handleCouncilAndLandConsentNumberChange(idx)}
                                                className="form-control"
                                            />
                                        </td>
                                        <td style={{ width: "40%" }}>
                                            <textarea
                                                type="textarea" rows="3"
                                                name="consentConditions"
                                                value={councilAndLandRows[idx].consentConditions}
                                                onChange={handleCouncilAndLandConsentConditionsChange(idx)}
                                                className="form-control"
                                            ></textarea>
                                        </td>
                                        <td style={{ width: "17%" }}>
                                            <DatePicker selected={councilAndLandRows[idx].expiryDate != null ? getDateFromString(moment(councilAndLandRows[idx].expiryDate).format("DD/MM/YYYY")) : null}
                                                onChange={(date) => handleConsentDateChange(idx, date)}
                                                name="expiryDate"
                                                showYearDropdown
                                                dateFormatCalendar="MMMM"
                                                yearDropdownItemNumber={15}
                                                scrollableYearDropdown
                                                fixedHeight
                                                className="form-control" />
                                        </td>
                                        {/*{showEnvironmentCanterbury && */}
                                        {/*    <td style={{ width: "5%", textAlign: 'center' }}>*/}
                                        {/*        <Input type="checkbox" checked={councilAndLandRows[idx].requiredForFEP} onChange={handleCouncilAndLandConsentRequiredForFEPChange(idx)} name="requiredForFEP" id="requiredForFEP" />*/}
                                        {/*    </td>}*/}
                                        <td style={{ width: "12%" }}>
                                            {councilAndLandRows[idx].documentRelativePath != null && councilAndLandRows[idx].documentRelativePath != '' ?
                                                <Row>
                                                    <Col>
                                                        <a href={councilAndLandRows[idx].documentRelativePath} target='_blank'>
                                                            <img src="/images/File_icon.png" className="PDF_icon" ></img>
                                                        </a>
                                                    </Col>
                                                    <Col>
                                                        {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                                                            <>
                                                            <Button style={{ float: `right` }} color="warning" size="sm" onClick={(e) => handleConsentBtnUploadClick(e, idx)} ><FaUpload /></Button>
                                                            </>
                                                        }
                                                    </Col>
                                                </Row>
                                                :<>
                                                    {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                                                    <>
                                                    <Button style={{ float: `right` }} color="success" size="sm" onClick={(e) => handleConsentBtnUploadClick(e, idx)} ><FaUpload /></Button>
                                                        </>
                                                    }
                                                </>
                                                
                                            }
                                            <br />
                                            <input style={{ float: `right`, display: 'none' }}
                                                ref={input => {
                                                    inputConsentFile[idx] = input;
                                                }}
                                                type="file" name="attachment" className="form-control" onChange={(e) => handleConsentRecordChange(e, idx)} />
                                            {formConsentErrors.length > 0 && formConsentErrors[idx] != undefined && formConsentErrors[idx].fileError != undefined &&
                                                <p className="errorMessage">{formConsentErrors[idx].fileError}</p>
                                            }
                                        </td>
                                        <td style={{ width: "5%" }}>
                                            {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                                                <>
                                            <button style={{ float: "right" }} onClick={handleCouncilAndLandRowsRemoveSpecificRow(idx)} type="button" id="btnUpdate" className="btn btn-sm btn-danger">
                                                <FaTrash />
                                                </button>
                                                </>
                                            }
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                            <>
                                <button onClick={handleCouncilAndLandRowsAddRow} type="button" id="btnUpdate" className="btn btn-sm btn-pluse-light">
                                    Add Consent
                                </button>
                            </>
                        }
                    </Col>
                </Row>
            </CardBody>
        </Card>
        )
}

export default CouncilAndLandInfo;